const config = {
  apiUrl: 'https://run.mocky.io/v3/',
  authToken: 'token',
  shortToken: 'shortToken',
  user: 'currentUser'
}
export default config
